import classnames from 'classnames';

import { CSSModule } from '../../typings/index.ts';

type Scalar = string | boolean | undefined | null | 0;

export type Variant = Scalar | Array<Scalar> | ReadonlyArray<Scalar>;

/**
 * Applies variants to a className using `--` as the delimiter
 * @returns {string} className variants
 * @param {string} baseClassName The className to apply variants to
 * @param {Object<string,string>} styleMap The CSS Module className mapping object
 * @param {...(string|boolean|Array<(string|boolean)>)} [variants] All the variants to apply
 */
export default function addVariants<T extends CSSModule>(
  base: string,
  styleMap: T,
  ...variants: Variant[]
): string {
  const variantsToAdd: Variant[] = ['default'];
  return classnames(
    base,
    styleMap[base],
    variantsToAdd
      .concat(variants)
      .reduce((arr, cur) => arr.concat(cur), [] as Variant[])
      .filter(Boolean)
      .map(variant => styleMap[`${base}--${variant}`])
  );
}
